export const STATIC_VARIANT = 'static'
export const TESTIMONIAL_PATTERN = '/images/testimonial-rating.svg'
export const H2REGEX = /<h2[^>]*>(.*?)<\/h2>/

export const ITEM_WIDTH = 380
export const VISIBLE_ITEMS = 3
